import { persistStore } from 'redux-persist';

import { configureAppStore } from 'store/configureStore';

export const store = configureAppStore();

export const persistor = persistStore(store);
